import { useContext } from "react";

import useLabel from "@apps/use-label/use-label";
import { classNames } from "@helpers/css";

import { OverallGoalAssessmentQuestionDescriptionContext } from "./overall-goal-question-context";

const OverallGoalAssessmentQuestionDescription = ({
  className,
}: {
  className?: string;
}) => {
  const context = useContext(OverallGoalAssessmentQuestionDescriptionContext);
  const label = useLabel();

  return context.averageScoreOfIndividualGoalBasedQuestions ? (
    <div className={classNames("mt-1 text-sm text-gray-500", className)}>
      Average score based on above {label("goal")} assessments:{" "}
      {context.averageScoreOfIndividualGoalBasedQuestions}/
      {context.scale ?? "3"}
    </div>
  ) : null;
};

export default OverallGoalAssessmentQuestionDescription;
